import { Component, Inject, OnInit } from '@angular/core';
import { MeasureService } from '../measure.service';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-modal-informant',
  templateUrl: './modal-informant.component.html',
  styleUrls: ['./modal-informant.component.scss']
})
export class ModalInformantComponent implements OnInit {

  modalData: any;
  canAccessReport: boolean = true;
  countFalse: number = 0;
  isEdit: boolean = false;
  informant_person: any[] = [];

  emailRegex = new RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$");
  canSend: boolean = true;

  informantForm: FormGroup;
  emailArrayForCheck: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalInformantComponent>,
    private measureService: MeasureService,
    private fb: FormBuilder,
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
    this.getParticipant();
  }

  getParticipant() {
    this.measureService.getParticipantByMeasure(this.modalData.MEASURE_ID).pipe(
      map(par => {
        if (par.success) {
          // this.informant_person = par.result;
          par.result.forEach(e => {
            this.informant_person.push({
              errorTips: 'อีเมลไม่ถูกต้อง',
              isError: e.EMAIL ? false : null,
              edit: false,
              editing: false,
              sendRequest: e.EMAIL ? 1 : 0,
              ...e
            })
          })
          console.log(this.informant_person);
          for (let i = 0; i < this.informant_person.length; i++) {
            const el = this.informant_person[i];
            if (!el.EMAIL) {
              this.canSend = false;
              break;
            }
          }

          this.informantForm = this.fb.group({
            MEASURE_ID: [this.modalData.MEASURE_ID],
            TO: this.fb.array([])
          })

          this.getInformant();
          this.setForm();
        }
      })
    ).subscribe();
  }

  getInformant() {
    for (let i = 0; i < this.informant_person.length; i++) {
      if (this.informant_person[i].COMPLETED === 0) {
        this.canAccessReport = false;
        this.countFalse++;
      }
    }
  }

  setForm() {
    this.informant_person.forEach(e => {
      console.log(e);
      (<FormArray>this.informantForm.get('TO')).push(this.fb.group({
        MEASURE_CLIENT_EMAIL: [e.EMAIL, [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
        TAG: [e.TAG]
      }))
    })
  }

  checkUser(form, email, i) {
    let emailArr = this.emailArrayForCheck;
    let removeIndex = emailArr.splice(i, 1);

    if (email) {
      if (this.emailRegex.test(email)) {
        if (form.valid) {
          if (email !== this.modalData.userEmail) {
            if (emailArr.some(val => val['MEASURE_CLIENT_EMAIL'] === email)) {
              form.controls['MEASURE_CLIENT_EMAIL'].setErrors({ 'incorrect': true });
              this.informant_person[i].errorTips = 'อีเมลซ้ำ';
              this.informant_person[i].isError = true;
              this.informant_person[i].sendRequest = 0;
              this.canSend = false;
            } else {
              this.measureService.getUserByEmail(email).pipe(
                debounceTime(500),
                map(res => {
                  // if (res.result.length === 0) {
                  //   form.controls['MEASURE_CLIENT_EMAIL'].setErrors({ 'incorrect': true });
                  //   this.informant_person[i].errorTips = 'ไม่พบข้อมูลผู้ใช้ในระบบ กรุณาลงทะเบียนในระบบก่อนนำมาใช้งาน';
                  //   this.informant_person[i].isError = true;
                  //   this.informant_person[i].sendRequest = 0;
                  //   this.canSend = false;
                  //   console.log(res);

                  // } else {
                  // success
                  this.informant_person[i].sendRequest = 1;
                  this.informant_person[i].isError = false;

                  // console.log(this.informant_person);
                  let inCompleteArr = this.informant_person.filter(c => c.COMPLETED === 0);
                  console.log(inCompleteArr);
                  let count = 0;
                  for (let i = 0; i < inCompleteArr.length; i++) {
                    const el = inCompleteArr[i];
                    if (el.sendRequest === 0) {
                      break;
                    } else {
                      count++;
                    }
                  }
                  if (count === inCompleteArr.length) {
                    this.canSend = true;
                  }

                  // }
                })
              ).subscribe();
            }
          } else {
            form.controls['MEASURE_CLIENT_EMAIL'].setErrors({ 'incorrect': true });
            this.informant_person[i].errorTips = 'ไม่สามารถใส่อีเมลของตัวเองได้';
            this.informant_person[i].isError = true;
            this.informant_person[i].sendRequest = 0;
            this.canSend = false;
          }

        } else {
          this.informant_person[i].sendRequest = 0;
          this.informant_person[i].isError = true;
          this.canSend = false;
        }
      } else {
        this.informant_person[i].sendRequest = 0;
        this.informant_person[i].isError = true;
        this.informant_person[i].errorTips = 'อีเมลไม่ถูกต้อง';
        this.canSend = false;
      }
    } else {
      this.informant_person[i].sendRequest = 0;
      this.informant_person[i].isError = true;
      this.informant_person[i].errorTips = 'อีเมลไม่ถูกต้อง';
      this.canSend = false;
    }

    this.informant_person[i].editing = false;
  }

  checkEdit(informant) {
    informant.editing = true;
  }

  checkArray() {
    this.emailArrayForCheck = this.informantForm['controls'].TO.value.slice();
    // console.log(this.emailArrayForCheck);
  }

  editInformant() {
    this.informant_person.forEach(el => {
      if (!el.done) {
        el.edit = !el.edit;
      }
    });

    this.isEdit = !this.isEdit;
  }

  changeInformant(form) {
    console.log(form)
    const response = {
      status: true,
      type: 'change',
      body: form
    }
    this.dialogRef.close(response);
  }

  report() {
    const response = {
      status: true,
      type: 'report',
    }
    this.dialogRef.close(response);
  }

  closeModal() {
    const response = {
      status: false,
    }

    this.dialogRef.close(response);
  }

  sendAndTake(form) {
    const response = {
      status: true,
      body: form
    }

    this.dialogRef.close(response);
  }

  takeMeasure() {
    const response = {
      status: true,
      type: 'take',
    }
    this.dialogRef.close(response);
  }

}
